<template>
  <v-container fluid>
    <base-material-card
          color="primary"
          icon="mdi-script"
          inline
        >
        <v-card-text>
          <v-row>
            <v-col cols="12" class="headline">
              {{text}}
            </v-col>
          </v-row>
          <div class="text-center display-2 grey--text font-weight-light mb-6" v-if="enabled">
            Фотографии
          </div>
          <v-row class="mx-auto" v-if="enabled">
            <v-col cols="12">
              <v-form>
                <v-container class="py-0">
                  <v-card
                    class="elevation-1"
                    text
                  >
                    <v-progress-linear
                      class="ma-0"
                      color="secondary"
                      :indeterminate="loader.show"
                    />
                    <v-card-text>
                      <v-data-table
                        hide-default-footer
                        hide-default-header
                        :items="form.photos"
                        :headers="table.headers"
                        class="table_photos"
                      >
                        <template v-slot:item.image="{item}">
                          <v-img
                            max-width="100"
                            :src="get_src(item.id)"
                            @click="dialog_photos(item)"
                          />
                        </template>
                        <template v-slot:item.description="{item}">
                          <v-text-field
                            v-model="item.description"
                            :disabled="loader.show"
                            label="Описание"
                          />
                        </template>
                        <template v-slot:item.delete="{item}">
                          <v-icon
                            @click="form.photos = form.photos.filter(a=>a!=item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-btn
                        v-if="form.photos && form.photos.length < max_col"
                        color="primary"
                        text
                        :disabled="loader.show"
                        @click="$refs.upload.click()"
                      >
                        Добавить файл
                      </v-btn>
                      <input
                        ref="upload"
                        type="file"
                        multiple="true"
                        style="display: none;"
                        accept="image/*"
                        @change="async_upload_photos"
                      >
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="enabled">
          <v-btn color="primary" @click="send" min-width=100>
            Сохранить
          </v-btn>
        </v-card-actions>
    </base-material-card>
    <v-dialog v-model="dialog.photos.show">
      <v-carousel
        v-model="dialog.photos.slide"
        :continuous="false"
        hide-delimiter-background
        max-height="300"
        color="gray"
        class="carousel_photo"
      >
        <v-carousel-item
          v-for="(item,i) in form.photos"
          :key="i"
          :src="get_src(item.id)"
        >
          <v-row
            class="fill-height"
            align="start"
            justify="end"
          >
            <v-btn
              class="mr-5 mt-2"
              color="primary"
              height="30px"
              tile
              outlined
              :disabled="loader.show"
              @click="open_file(item.id)"
            >
              <v-icon>mdi-download</v-icon><span class="mr-1">Скачать</span>
            </v-btn>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    name: 'UploadPhoto',

    data () {
      return {
        max_col: 10,
        dialog: {
          photos: {
            show: false,
            slide: 0,
          },
        },
        loader: {
          show: false
        },
        form: {
          photos: []
        },
        table: {
          headers: [
          {
            text: 'Изображение',
            value: 'image',
          },
          {
            text: 'Описание',
            value: 'description',
          },
          {
            text: 'Удалить',
            value: 'delete',
          },
          ]
        },
        text: '',
        enabled: false
      }
    },
    computed: {

    },
    methods: {
      send: function(){
        this.form.id = this.$route.query.id
        this.axios.post('/api/photo/upload', this.form)
          .then(result => {
            if (!result.data.error) {
              this.text = result.data.data
              this.enabled = false
            } else {
              this.text = result.data.data
              this.enabled = false
            }
          })
          .catch(e => {
            this.text = 'Произошла ошибка при загрузке фотографий. Попробуйте еще раз'
          })
      },
      open_file: function (item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      dialog_photos: function (item) {
        this.dialog.photos.slide = this.form.photos.indexOf(item)
        this.dialog.photos.show = true
      },
      get_src: function (id) {
        return '/api/common/document/' + id
      },
      async_upload_photo: async function (file) {
        if (file) {
          let data = new FormData()
          data.append('file', file)
          await this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar',response.data.data ||  'Ошибка при сохранении данных')
              } else {
                for (let x in response.data.data) {
                  response.data.data[x].angle = 1
                  this.form.photos.push(response.data.data[x])
                }
              }
            })
            .catch(error => {
              if (error.indexOf('413')>-1) this.$store.commit('snackbar','Превышены размеры загружаемого файла')
              else this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
            })
        }
      },
          processFile: function(file) {
      if (file) {
        var pattern = /(image.jpg|image.jpeg|image.png)/;
        if (!file.type.match(pattern)) {
          return false;
        } else {
          return true;
        }
      }
    },
      async_upload_photos: async function (event) {
        const files = event.target.files
        let new_photos_limit = 0
        let msg = ''
        this.loader.show = true
        if ((this.max_col - this.form.photos.length) >= files.length) {
          new_photos_limit = files.length
        } else if (this.form.photos.length < this.max_col) {
          new_photos_limit = this.max_col - this.form.photos.length
          msg = 'Добавятся не все фотографии (Лимит ' + this.max_col + ' фотографий)'
        } else {
          msg = 'Лимит ' + this.max_col + ' фотографий'
        }
        if (new_photos_limit > 0) {
          this.loader.show = true
          for (let i = 0; i < new_photos_limit; i++) {
            if (this.processFile(files[i])) {
              await this.async_upload_photo(files[i])
            } else {
              this.$store.commit('snackbar', 'Неверный формат файла')
            }
          }
        }
        this.loader.show = false
      },
    },
    mounted: function() {
      this.axios.post('/api/photo/check', { id: this.$route.query.id})
          .then(result => {
            if (!result.data.error) {
              this.text = result.data.data
              this.max_col = Number(result.data.col)
              this.enabled = true
            } else {
              this.text = result.data.data
              this.enabled =false
            }
          })
          .catch(e => {
            this.text = 'Произошла ошибка при загрузке страницы'
            this.enabled = false
          })
    }
  }
</script>
